<template>
    <div class="product-rating">
        <v-rating
            v-model="rating"
            background-color="#ff6347"
            color="#ff6347"
            dense
            size="10"
            small
            readonly>
            <slot></slot>
        </v-rating>
        <div v-if="sideNumberVisible" class="product-rating__count">({{ rating }})</div>
    </div>
</template>

<script>
export default {
    props: {
        rating: {
            type: Number,
            default : 0,
        },
        sideNumberVisible: {
            type: Boolean,
            default : true,
        },
    },

    data: () => ({

    })
}
</script>

<style lang="scss">
    .product-rating
    {
        justify-self: end;
        display: flex;

        > div {
            font-size: 10px;
        }

        .product-rating__count
        {
            opacity: .3;
        }

        .v-rating {
            .v-icon {
                font-size: 10px !important;
                padding: 0.1rem 0;
            }
        }
    }
</style>
